import {FC, useState} from 'react'
import {storeBooking} from "../../lib/booking";
import {formatSlug} from "../../lib/helpers";

interface Props {
    mechanics:any,
    booking:Booking,
    setBooking:Function
}

const Volvo: FC<Props> = ({mechanics, booking, setBooking}) => {

    const [mechanic, setMechanic] = useState(booking.options_extra.volvo_pst)
    const updateMechanic = (e: any) => {
        setMechanic(e.target.value)
        booking.options_extra.volvo_pst = e.target.value
        storeBooking(booking, setBooking)
    }

    if(booking.booking_flow === 'hjulskifte' || booking.service.booking_flow === 'window' || formatSlug(booking.car.brand) !== 'volvo' || !mechanics.active) {
        return
    }

    // Do not show option for pts when booking only includes hjulskifte (service product)
    if(booking.service.slug.includes('hjulskifte')) {
        return
    }

    return (
        <>
            <ul className="wco-order-options_list brand-extra-option">
                <li className="volvo-mechanic input-outer chk-box">
                    <div className="li-text">
                        <div className="description">
                            <h3>{mechanics.header}</h3>
                            {mechanics.description && (
                                <div className={'mb-2'}>{mechanics.description}</div>
                            )}
                        </div>
                        <div className="select-style-bg">
                            <div className="select-style person">
                                <select title="PST" id="booking-pst" value={mechanic} onChange={updateMechanic}>
                                    <option value="" disabled>Välj</option>
                                    {mechanics.options.map((mechanic: any, i: number) => (
                                        <option key={i} value={mechanic}>{mechanic}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </>
    )
};

export default Volvo
